import services from 'services/module';
import {HttpSvcFactory} from './HttpSvc';

export class BackendSvc {

    constructor(private HttpSvc: HttpSvcFactory,
                private $q: ng.IQService) {
    }

    getProjectBackend = <(s: string) => ng.IPromise<string>>_.memoize((projectId: string) =>
        this.$q(resolve => {
                const method = options.user.anonymous ? 'get' : 'secureGet';
                return this.HttpSvc('project-api', projectId)
                    [method]()
                    .then((response: ng.IHttpPromiseCallbackArg<{url: string}>) => resolve(response.data.url));
            }
        ));

    getServerUrl(project: anm.Project): ng.IPromise<string> {
        const promise = project.serverUrl ? this.$q.resolve(project.serverUrl) : this.getProjectBackend(project.id);
        return promise.then(url => this.formatUrl(url));
    }

    formatUrl(url: string) {
        if (url.indexOf('localhost') === -1) {
            url = url.replace(/(:\d{2,6})/, '');
        }
        const serverUrl: string = url.replace(/^https?:\/\//, '');
        return `//${serverUrl}`;
    }
}

services.service('BackendSvc', BackendSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/BackendSvc.ts